export function formatPence(moneyInPence, currency) {
  const parsedPence = Number.parseFloat(moneyInPence);
  const noPenceMoney = parseInt((parsedPence / 100));
  return `${currencySymbol(currency)}${noPenceMoney.toLocaleString()}`;
}

export function currencySymbol(currency) {
  switch(currency) {
    case 'GBP': return '£';
    case 'USD': return '$';
  }
}